/**
 * Layout component that queries for data
 * with Gatsby's useStaticQuery component
 *
 * See: https://www.gatsbyjs.org/docs/use-static-query/
 */

import React from "react"
import PropTypes from "prop-types"
import { useStaticQuery, graphql } from "gatsby"
import styled from "@emotion/styled"

import Header from "./header"
import "./layout.css"

const GlobalStyles = styled.div`
  background-color: #dbf26e;
  background-image: linear-gradient(
    319deg,
    #dbf26e 0%,
    #61fa74 37%,
    #1cfdd6 100%
  );
  height: 100vh;
  font-family: Iosevka;
  src: url("Iosevka.woff2") format("woff2");
`

const Layout = ({ children }) => {
  const data = useStaticQuery(graphql`
    query SiteTitleQuery {
      site {
        siteMetadata {
          title
        }
      }
    }
  `)

  return (
    <GlobalStyles>
      <Header siteTitle={data.site.siteMetadata.title} />
      <div
        style={{
          margin: `0 auto`,
          maxWidth: 960,
          padding: `0 1.0875rem 1.45rem`,
          display: "flex",
          flexDirection: "column",
        }}
      >
        <main style={{ padding: `0 30%` }}>{children}</main>
        <footer
          style={{
            textAlign: "end",
            alignContent: "flex-end",
            position: "fixed",
            bottom: "10px",
            right: "20px",
          }}
        >
          © {new Date().getFullYear()}
          {/* , Built with
          {` `}
          <a href="https://www.gatsbyjs.org">Gatsby</a> */}
        </footer>
      </div>
    </GlobalStyles>
  )
}

Layout.propTypes = {
  children: PropTypes.node.isRequired,
}

export default Layout
